export default "__VITE_ASSET__b60e7429__"